import service from '@/utils/server';

const modName='/tms/sign/';
//查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//异常签收产品明细
export const matDetails = data => {
  return service({
    url: modName + 'matDetails',
    method: 'post',
    data
  });
};

//异常签收原因编码
export const exceptionReason = data => {
  return service({
    url: modName + 'exceptionReason',
    method: 'post',
    data
  });
};

//提交数据
export const signSubmit = data => {
  return service({
    url: modName + 'signSubmit',
    method: 'post',
    data
  });
};

export const signBatchSubmit = data => {
  return service({
    url: modName + 'signBatchSubmit',
    method: 'post',
    data
  });
};

//模板下载
export const downloadTemplate = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'downloadTemplate/' + data,
    method: 'post',
    data
  });
};

//导入数据
export const importData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'import',
    method: 'post',
    data
  });
};


//导出数据
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//签收详情
export const signDetails = data => {
  return service({
    url: modName + 'signDetails',
    method: 'post',
    data
  });
};

//签收回退
export const signBack = data => {
  return service({
    url: modName + 'signBack',
    method: 'post',
    data
  });
};


//回单批量提交
export const receiptBatchSubmit = data => {
  return service({
    url: modName + 'receiptBatchSubmit',
    method: 'post',
    data
  });
};


//回单提交
export const receiptSubmit = data => {
  return service({
    url: modName + 'receiptSubmit',
    method: 'post',
    data
  });
};

//回单确认
export const receiptConfirm = data => {
  return service({
    url: modName + 'receiptConfirm',
    method: 'post',
    data
  });
};
/**
 * 上传附件
 * @param data
 * @returns {*}
 */
export const uploadFile = data => {
  let config={
    headers: {
      "Accept": '*/*',
      'Content-Type': 'multipart/form-data'
    }
  }
  return service({
    ...config,
    url: modName + 'uplodFile',
    method: 'post',
    data
  });
};

/**
 * 上传附件-增加业务校验
 * @param data
 * @returns {*}
 */
export const uploadReceiptCheck = data => {
  let config={
    headers: {
      "Accept": '*/*',
      'Content-Type': 'multipart/form-data'
    }
  }
  return service({
    ...config,
    url: modName + 'uploadReceiptCheck',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/sign/api/index.js